module.exports = __webpack_public_path__ + "img/key_features--accessories.81a468a4.png";